import { useState } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { aiChatAPI } from '../lib/api';
import { toast } from 'sonner';

export function AIEnhanceButton({ text, onEnhanced, className = '' }) {
  const [loading, setLoading] = useState(false);
  const [showStyles, setShowStyles] = useState(false);

  const enhance = async (style) => {
    if (!text?.trim()) { toast.error('Write something first'); return; }
    setLoading(true);
    setShowStyles(false);
    try {
      const res = await aiChatAPI.enhanceText(text, style);
      onEnhanced(res.data.enhanced);
      toast.success('Text enhanced');
    } catch { toast.error('Enhancement failed'); }
    setLoading(false);
  };

  return (
    <div className={`relative inline-flex ${className}`}>
      <button
        type="button"
        onClick={() => setShowStyles(!showStyles)}
        disabled={loading || !text?.trim()}
        className="flex items-center gap-1 px-2 py-1 rounded-md text-[10px] text-gold/60 hover:text-gold hover:bg-gold/5 transition-colors disabled:opacity-30"
        title="AI enhance writing"
        data-testid="ai-enhance-btn"
      >
        {loading ? <Loader2 className="h-3 w-3 animate-spin" /> : <Sparkles className="h-3 w-3" />}
        <span>Enhance</span>
      </button>
      {showStyles && (
        <div className="absolute bottom-full left-0 mb-1 bg-card border border-border/40 rounded-lg shadow-xl z-50 py-1 min-w-[140px]">
          {[
            { style: 'professional', label: 'Professional' },
            { style: 'casual', label: 'Casual & Friendly' },
            { style: 'creative', label: 'Creative' },
          ].map(s => (
            <button key={s.style} onClick={() => enhance(s.style)} className="w-full px-3 py-1.5 text-left text-[11px] hover:bg-foreground/[0.03] transition-colors">
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
